/* @ngInject */ export function DepositHistoryService(HTTPService) {
  var http = HTTPService.make('/books/depositHistory/');

  this.getDefaultBank = function () {
    return http.get('getDefaultBank');
  };
  this.getDepositList = function () {
    return http.get('getDepositList');
  };
  this.getSummary = function (id) {
    return http.get(`getSummary/${id}`);
  };
};
